import * as _ from 'node_modules/underscore/underscore.js';

export default class msuMobileHeaderNav {
    constructor() {
        this.active = false;

        this.elements = {
            $body: $('body'),
            $open: $('.open-mobile-menu-btn-js'),
            $navContainer:         $('.msu-mobile-nav-container-js'),
            $nav:                  $('.msu-mobile-nav-container-js').find('.msu-mobile-nav-js'),
            $navBg:                $('.msu-mobile-nav-container-js').children('.msu-mobile-background-js'),
            $close:                $('.msu-mobile-nav-container-js').find('.close-nav-js'),
            $submenuToggleButtons: $('.msu-mobile-nav-container-js').find('.toggle-submenu-js'),
            $lastTopLevelLink:     $('.msu-mobile-nav-container-js').find('.msu-mobile-nav-list-js > .nav-item-container:last-child > button'),
            $lastSubLevelLink:     $('.msu-mobile-nav-container-js').find('.msu-mobile-nav-list-js > .nav-item-container:last-child > button').siblings().find('.nav-item-container:last-child > a'),
        };

        // move entire Nav element (background, container, menu) to top level of DOM
        // this allows us to bypass overflow:hidden and clip-path CSS rules (otherwise the menu may be cut-off/clipping)
        this.elements.$body[0].insertBefore(this.elements.$navContainer[0], null);

        this._bindEventListeners();
    }

    // Open or close nav
    toggleNav() {
        //this.active = this.elements.$navContainer[0].classList.toggle('active');
        this.active = this.elements.$navContainer.toggleClass('active').hasClass('active');
        this.elements.$body.toggleClass('mobile-nav-active');

        // Mobile menu toggle accessibility
        this.elements.$open.attr('aria-pressed',  this.active);
        this.elements.$open.attr('aria-expanded', this.active);
        this.elements.$close.attr('aria-pressed', !this.active);
        this.elements.$close.attr('aria-expanded', this.active);

        // aria-hidden prevents screen readers from leaving the menu, as all other elements are now 'hidden' from it
        $(document).find('body > *:not(.msu-mobile-nav-container, script)').attr('aria-hidden', this.active);

        setTimeout(() => {
            this.active ? this.elements.$close.focus() : this.elements.$open.focus();
        }, 400);
    }

    // Open or close a submenu within the menu
    _toggleSubmenu( event ) {
        // .currentTarget = element the event listener was attached to
        // .target = event that was clicked (usually lower level spans or icons)
        let button = event.currentTarget;
        let submenu = button.nextElementSibling;
        let open = $(submenu).toggleClass('active').hasClass('active');

        open ? $(submenu).find('[tabindex="-1"]').attr('tabindex', 0)
            : $(submenu).find('[tabindex="0"]').attr('tabindex', -1);

        $(button).attr('aria-expanded', open);
    }

    // Handle shift+tabbing on the 'close submenu' button at the top of the menu
    _closeBtnTab( event ) {
        if ( event.shiftKey && event.which === 9 ) {
            event.preventDefault();

            // Determine if the submenu is open.
            // .getAttribute() returns a 'true' or 'false' string, both of which are truthy, so we need strict comparison here.
            (this.elements.$lastTopLevelLink.attr('aria-expanded') === 'true')
                ? this.elements.$lastSubLevelLink.focus() : this.elements.$lastTopLevelLink.focus();
        }
    }

    // Handle tabbing and shift+tabbing on the last link in the menu
    _lastLinkTab( event ) {
        // determine if the submenu is open here
        if ( event.currentTarget === this.elements.$lastTopLevelLink[0]
            && (this.elements.$lastTopLevelLink.attr('aria-expanded') === 'true')
        ) {
            return;
        }

        if ( !event.shiftKey && event.which === 9 ) {
            event.preventDefault();
            this.elements.$close.focus();
        }
    }

    // If the mobile menu is open, and the window is resized to desktop view, trigger closing the menu
    _checkResponsive() {
        if ( this.active && Modernizr.mq('(min-width: 1024px)') ) {
            this.toggleNav();
        }
    }

    _bindEventListeners() {
        // Core
        this.elements.$open.click  ( () => this.toggleNav () );
        this.elements.$close.click ( event => this.toggleNav ( event ) );
        this.elements.$navBg.click ( event => this.toggleNav ( event ) );
        this.elements.$submenuToggleButtons.click ( this._toggleSubmenu );
        this.elements.$body.keydown ( e => {
            let key = e.keyCode || e.which;

            if (this.active && key === 27) {
                this.toggleNav();
            }
        });

        // Accessibility
        this.elements.$close.keydown ( event => this._closeBtnTab ( event ) );
        this.elements.$lastTopLevelLink.keydown ( event => this._lastLinkTab ( event ) );
        this.elements.$lastSubLevelLink.keydown ( event => this._lastLinkTab ( event ) );

        // Responsive
        $(window).resize(_.debounce(() => {
            this._checkResponsive();
        }, 400));
    }
}
